import { render } from "./LanguageDropdown.vue.ts?vue&type=template&id=6da687a8&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./LanguageDropdown.vue?vue&type=template&id=6da687a8&scoped=true&ts=true"
import script from "./LanguageDropdown.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./LanguageDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageDropdown.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./LanguageDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageDropdown.vue.scss?vue&type=style&index=0&id=6da687a8&lang=scss&scoped=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./LanguageDropdown.vue?vue&type=style&index=0&id=6da687a8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da687a8"],['__file',"src/apps/person-registration/shared-components/ui/LanguageDropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6da687a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6da687a8', __exports__)) {
    api.reload('6da687a8', __exports__)
  }
  
  module.hot.accept("./LanguageDropdown.vue.ts?vue&type=template&id=6da687a8&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./LanguageDropdown.vue?vue&type=template&id=6da687a8&scoped=true&ts=true", () => {
    api.rerender('6da687a8', render)
  })

}


export default __exports__